<template>
    <div class="posted-by">
        <div class="bg-light border add-rounded mt-5 px-3 pb-3">
                        <h4 class="font-weight-bolder mt-4 text-left">Currently Hired: 4</h4>
                        <div class="row">
                            <div class="col-4 col-md-5 col-lg-4">
                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                            </div>
                            <div class="col-8 col-md-7 col-lg-8 pl-3">
                                <h3 class="font-weight-bolder kova-text text-left employer-name">Johnson. K </h3>
                                <h5 class="text-left mb-0">Web Developer</h5>
                                <h6 class="intermediate text-uppercase font-weight-bolder text-left text-size4">intermediate</h6>
                                <div class="text-left mt-4">
                                    <span class="btn-kovatek py-2 px-3 text-size3" @click="message">Send Direct Message</span>
                                </div>
                            </div>
                        </div>
                        <div class="bg-kovatek m-2 m-md-1 m-lg-3 p-4 add-rounded">
                            <div class="row text-left">
                                <div class="col-8 text-white"><h4 class="text-white text-size2">Skill Score</h4></div>
                                <div class="col-4 text-white"><h4 class="text-white text-size2">65%</h4></div>
                            </div>
                            <div class="row text-left">
                                <div class="col-8 text-white"><p class="text-size3">Profile</p></div>
                                <div class="col-4 text-white"><p class="text-size3">19</p></div>
                            </div>
                            <div class="row text-left">
                                <div class="col-8 text-white"><p class="text-size3">Sprint Project Exercise</p></div>
                                <div class="col-4 text-white"><p class="text-size3">22</p></div>
                            </div>
                            <div class="row text-left">
                                <div class="col-8 text-white"><p class="text-size3">Live Interview</p></div>
                                <div class="col-4 text-white"><p class="text-size3">24</p></div>
                            </div>
                            <button class="see-more px-3 px-md-4 px-lg-5 py-2 mt-3" @click="skillScore">see more</button>     
                        </div>
                    </div>
    </div>
</template>

<script>
export default {
    name: 'posted-by',
    data(){
        return {

        }
    },
    methods: {
        skillScore(){
            this.$router.push('skill-score');
        },
        message(){
            this.$router.push('chat');
        }
    }
}
</script>

<style scoped>
.kova-text{
    color: #20409a;
}
.icon-size{
    font-size: 25px;
}
.btn-kovatek{
  background-color: #20409A;
  font-weight: bold;
  outline: 0;
  border: 0;
  width: 255px;
  height: 45px;
  color: #fff;
  border-radius: 30px;
  transition: .25s;
  font-size: 18px;
}
.btn-kovatek:hover{
  background-color: #06216d;
  color: #fff;
}
.bg-kovatek{
  background-color: #20409A;
}
.img-height{
    width: 120px;
    height: 120px;
}
.icon-env{
    font-size: 20px;
}
.text-size1{
    font-size: 20px;
}
.text-size2{
    font-size: 18px;
}
.text-size3{
    font-size: 11px;
}
.text-size4{
    font-size: 14px;
}
@media screen and (min-width: 992px) and (max-width: 1325px){
    
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .employer-name{
        font-size: 18px;
    } 
    .img-height{
        width: 100px;
        height: 100px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   
}

@media screen and (max-width: 767px){

}
</style>